import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
import { SBPIcon } from "./styled"

const SBPIconNoExt = ({ size }: { size: number }) => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "center",
    }}
  >
    <SBPIcon iconName="sbpIcon" sx={{ margin: 0, ml: -1.5 }} size={size} />
    <Typography
      sx={{ fontWeight: 700, ml: -1.5, mb: "4px" }}
      variant="h3"
      color="initial"
    >
      сбп
    </Typography>
  </Box>
)

export default SBPIconNoExt
